var axios = require('axios')

const getVersionedUrl = (params) => {
    if (typeof params === 'string') {
      params = params.split('&').reduce((acc, part) => {
        const [key, value] = part.split('=');
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
    }

    const outletCode = params.outlet_code
    const menuV4Stores = JSON.parse(localStorage.getItem('jp_use_menu_v4_api_stores')) || []
    let version = process.env.version2;
    
    if (menuV4Stores.includes(outletCode)) {
        console.log("Using v4 API")
        version = process.env.version4;
    } else {
        console.log("Using v2 API")
    }

    const url = version + '/product-menu-fe'
    const urlMenu = version + '/product-menu-fe/menu'
    const urlCutlery = version + '/product-menu-fe/cutlery'
    const urlMenuCombo = version + '/product-menu-fe/menu/'
    const urlCategory = version + '/product-menu-fe/category'
    const urlHalfFirst = version + '/product-menu-fe/first-layers'
    const urlHalfSecond = version + '/product-menu-fe/second-layers'
    const urlFriendlyNameSeo = version + '/product-menu-fe/menu-by-nameseo'
    const urlPlasticBag = version + '/product-menu-fe/get-item-by-type'

    return {
      url,
      urlMenu,
      urlCutlery,
      urlMenuCombo,
      urlCategory,
      urlHalfFirst,
      urlHalfSecond,
      urlFriendlyNameSeo,
      urlPlasticBag
    }
} 

axios.getHalf = function (type, data, success, callBackError) {
    axios.options.flag = false
    var urlHalfFirst = getVersionedUrl(data).urlHalfFirst;
    var urlHalfSecond = getVersionedUrl(data).urlHalfSecond;

    var url = urlHalfFirst;
    if (type == 2) {
        url = urlHalfSecond;
    }

    this.get(url, {params: data})
        .then(response => {
            success(response)
        }).catch(error => {
        if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
            if (typeof callBackError !== 'undefined') {
                callBackError(error.response.data)
            }
        }
    })
}

axios.getMenuByCategory = function (data, success, callBackError) {
  const { urlMenu } = getVersionedUrl(data)

  axios.options.flag = false
  this.get(urlMenu, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (typeof callBackError !== 'undefined') {
        let errorTmp = (error.response && error.response.data) ? error.response.data : ''
        callBackError(errorTmp)
      }
    })
}

axios.getAddOnByCategory = function (data, success, callBackError) {
  const { url } = getVersionedUrl(data)

  axios.options.flag = false
  this.get(url + '/add-on?', {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuCombo = function (data, success, callBackError) {
  const { urlMenuCombo } = getVersionedUrl(data)

  this.get(urlMenuCombo, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getMenuDetails = function (uuid, data, success, callBackError) {
  const { urlMenu } = getVersionedUrl(data)

  this.get(urlMenu + '/' + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getComboDetails = function (uuid, data, success, callBackError) {
  const { urlMenuCombo } = getVersionedUrl(data)

  this.get(urlMenuCombo + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getListCategory = function (data, success, callBackError) {
  const { urlCategory } = getVersionedUrl(data)

  axios.defaults.headers.common['Lang'] = data['lang'] || axios.defaults.headers.common['Lang']
  axios.options.flag = false
  let url = urlCategory + '?' + data
  this.get(url, data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCutlery = function (data, success, callBackError) {
  const { urlCutlery } = getVersionedUrl(data)

  axios.options.flag = false
  this.get(urlCutlery, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getListHalf = function (data, success, callBackError) {
  const { urlMenu } = getVersionedUrl(data)
  
  axios.options.flag = false
  this.get(urlMenu, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getComboDetailsFriendlyNameSeo = function (data, success, callBackError) {
  const { urlFriendlyNameSeo } = getVersionedUrl(data)

  axios.options.flag = true
  this.get(urlFriendlyNameSeo, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getPlasticBag = function (data, success, callBackError) {
  const { urlPlasticBag } = getVersionedUrl(data)

  axios.options.flag = true
  this.get(urlPlasticBag, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Menu.js